var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-checkbox",on:{"click":_vm.change}},[_c('span',{staticClass:"base-checkbox-icon",class:{ checked: _vm.checked, disabled: _vm.disabled }},[_c('svg-icon',{attrs:{"icon-class":"global_icon_gou"}})],1),_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }